import React from 'react';
import { TabletButtonStyled } from './styles/TabsStyled';
var TabIcon = function TabIcon(_ref) {
  var icon = _ref.icon;
  return React.createElement(TabletButtonStyled, null, " ", icon, " ");
};
export default TabIcon;